import instanceAxios from "../config/config";

const create = (data: any) => {
    return instanceAxios.post("/login", data);
};

const AuthServices = {
    create,
};

export default AuthServices;
